function noop(..._args: any[]): void {}

export { noop };
export default noop;
